module.exports = __webpack_public_path__ + "img/webpage-icon.a1a5eab2.svg";